import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-congres-virtuel-video',
  templateUrl: './congres-virtuel-video.component.html',
  styleUrls: ['./congres-virtuel-video.component.scss']
})
export class CongresVirtuelVideoComponent implements OnInit {

  @Input() vpdata = {display:false};

  constructor() { }

  ngOnInit() {
  }

  closeVidPopup(){
    this.vpdata.display = false;
  }

}
